export const WHATS_NEW_SIDEBAR_URL = 'https://announcekit.co/widgets/v2/1YLMNW';
